/**
 * Who operates Liciora (Chile, `cl`), as the Chilean legal set states it. The
 * same company as MiLicita's — AI CRM Inc, the Stripe card payee of the KZ, ES
 * and CL editions — identified by its name, Delaware address and Delaware
 * registry number (Liciora COMMON brief). No EIN is published and the company
 * has no Chilean RUT: none is stated rather than one invented.
 *
 * Kept apart from `content/legal/es/operator.ts` (which imports it to serve
 * Chile) so the two never import each other.
 */
export const CL_OPERATOR_FILE_NUMBER = '10163511';

/** = `brand.supportEmail` / `brand.siteUrl` of the cl country config (`cl-legal.test.ts`). */
export const CL_OPERATOR = {
  name: 'AI CRM Inc',
  address: '251 Little Falls Drive, Wilmington, DE 19808, Estados Unidos',
  brand: 'Liciora',
  site: 'https://liciora.cl',
  host: 'liciora.cl',
  email: 'support@liciora.cl',
  registry: `sociedad constituida en el Estado de Delaware (Estados Unidos), inscrita en la Division of Corporations del Delaware Department of State con el número de registro (file number) ${CL_OPERATOR_FILE_NUMBER}`,
  identification: `AI CRM Inc., sociedad constituida en Delaware (EE. UU.), número de registro ${CL_OPERATOR_FILE_NUMBER}`,
} as const;

/** Date of the current edition of every document in the Chilean set. */
export const CL_LEGAL_UPDATED = '25 de octubre de 2026';

/**
 * The data-source line in the footer of every page, and the substance of the
 * Aviso legal §4. Mercado Público is the procurement information system that the
 * Dirección de Compras y Contratación Pública (Dirección ChileCompra) runs; the
 * catalogue reads its open data (`mp-licitaciones`, `mp-compra-agil`).
 *
 * The exact reuse terms of those open data are NOT in the Chile research
 * (2026-10-24: «las condiciones de reutilización comercial, almacenamiento y
 * atribución» is one of the questions still to put to ChileCompra), so the line
 * is a neutral attribution: the source, independence, «verifica en la fuente
 * oficial». Replace it with the licence's own wording once ChileCompra answers.
 */
export const CL_DATA_SOURCE_ATTRIBUTION =
  'Origen de los datos: Mercado Público, Dirección ChileCompra (datos abiertos). ' +
  'Liciora es un servicio independiente: no está afiliado a la Dirección ChileCompra ni a ' +
  'Mercado Público, que no participan en él ni lo patrocinan. La información tiene carácter ' +
  'informativo y no oficial: verifica en la fuente oficial (www.mercadopublico.cl) las bases, ' +
  'sus modificaciones, los plazos y las notificaciones. La presentación de la oferta y las ' +
  'actuaciones con efectos jurídicos se realizan por los medios indicados oficialmente para ' +
  'cada procedimiento.';
